<template>
  <div class="wrapper">
  <AppLogo variant="prelogin"/>
  <div class="mb-25">
  <EmailConfirmation/>
  </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import AppLogo from "../../components/Widgets/AppLogo.vue";
import EmailConfirmation from "../../components/Authentication/EmailConfirmation/EmailConfirmation.vue";

export default defineComponent({
  name: "EmailConfirmationPage",
  components: {
    AppLogo,
    EmailConfirmation,
  },
});
</script>